<script setup lang="ts">
import type { ComponentArticleContentSectionProps } from "./ComponentArticleContentSection.props"
import { Remarkable } from "remarkable"
import { parse } from "node-html-parser"
import slugify from "@sindresorhus/slugify"

const props = defineProps<ComponentArticleContentSectionProps>()

const mdText = ref<string>("")
const remarkable = new Remarkable({ html: true })
const root = parse(remarkable.render(props.content))
for (const h of root.querySelectorAll("h2,h3")) {
  const slug = h.getAttribute("id") || slugify(h.textContent)
  h.setAttribute("id", slug)
  h.insertAdjacentHTML(
    "afterbegin",
    `<a class="header-anchor" href="#${slug}"></a> `
  )
}

mdText.value = root?.toString() ?? ""
</script>

<template>
  <div id="textWrapper" v-html="mdText"></div>
</template>
